import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';
import { createContext } from 'react';

export interface SupabaseConnectionContextType {
  supabase: SupabaseClient<Database>;
}

export const SupabaseConnectionContext = createContext<SupabaseConnectionContextType | undefined>(undefined);